import { STATUS_CHIP_BASE_CLASS, STATUS_CHIP_SIZE_STYLE } from '~/components/common/chips';
import { getSourceStatusBadgeClass } from '~/features/explorer/utils/products-catalog';
import { cn } from '~/utils/cn';

/**
 * Merchant-Center eligibility status pill (approved / disapproved / pending).
 * Shares StockAvailabilityChip's pill shape + size so it sits alongside the
 * availability chip at a matching style, tinted by the shared source-status
 * colour map. Renders nothing when the row carries no status.
 */
export function SourceStatusChip({
  status,
  className,
}: {
  status: string | null | undefined;
  className?: string;
}) {
  const value = (status ?? '').trim();
  if (!value) return null;

  return (
    <span
      className={cn(
        STATUS_CHIP_BASE_CLASS,
        'border capitalize',
        getSourceStatusBadgeClass(value),
        className,
      )}
      style={STATUS_CHIP_SIZE_STYLE}
    >
      {value}
    </span>
  );
}
